import {Action} from 'redux'
import {TAction} from './actions'
import {TOKEN_SET} from './actionTypes'
import {IState} from './model'

const initialState: IState = {
}

const reducer = (state: IState = initialState, action: TAction): IState => {
  switch (action.type) {
    case TOKEN_SET:
      return {
        ...state,
        token: action.payload.token,
      }
    default:
      return state
  }
}

// TODO: Workaround for redux typings issue. Fixed in redux v4.
// https://github.com/reactjs/redux/issues/2709
export default (state: IState, action: Action) => reducer(state, action as TAction)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/login/reducer.ts